import { ReactNode, useState } from 'react'
import { NotificationBar } from 'src/components'

import { NotificationContext } from 'src/containers/notification-context'
import { INotifyProps } from 'src/types'

interface INotificationProvider {
  children: ReactNode
}

const defaultNotification: INotifyProps = {
  timeout: 10000,
  message: null,
  icon: null,
  onButtonClick: null,
}
const NotificationProvider = ({ children }: INotificationProvider) => {
  const [notification, setNotification] = useState<INotifyProps>(defaultNotification)
  const [isShown, setIsShown] = useState(false)

  const notify = (props: INotifyProps) => {
    const onButtonClick = props.onButtonClick
      ? () => {
          props.onButtonClick?.()
          hide()
        }
      : null
    setNotification({
      ...defaultNotification,
      ...props,
      onButtonClick,
    })

    setIsShown(true)
  }

  const hide = () => {
    setIsShown(false)
  }

  return (
    <NotificationContext.Provider
      value={{
        isShown,
        notify,
        hide,
        ...notification,
      }}
    >
      {children}
      <NotificationBar />
    </NotificationContext.Provider>
  )
}

export default NotificationProvider
